import moment from "moment-timezone";
export function amountToCurrencyFormat(amount) {
  if (!amount)
    return "0";
  return (amount / 100).toFixed(2);
}
export function amountToCreditsFormat(amount, creditAmount) {
  if (!amount)
    return "0";
  return (amount / creditAmount).toFixed(0);
}
export function formatTime(date, timezone) {
  return moment(date).tz(timezone).format("h:mm a z").toUpperCase();
}
